import { useMemo } from 'react'
import { useParams as useRouterParams } from 'react-router-dom'
import debug from 'debug'

import { sanitizeParam, validateAllParams } from './route-param-validator'

const logger = debug('app:safe-params')

/**
 * Safe wrapper around React Router's useParams
 * Automatically validates and sanitizes route parameters to prevent XSS
 */
export function useSafeParams() {
  const rawParams = useRouterParams()

  const safeParams = useMemo(() => {
    try {
      // Attempt strict validation first
      return validateAllParams(rawParams)
    } catch (error) {
      // If strict validation fails, fall back to sanitization
      // This ensures the app doesn't break while still preventing XSS
      logger('Route parameter validation failed, falling back to sanitization:', error)

      const sanitized: Record<string, string> = {}
      for (const [key, value] of Object.entries(rawParams)) {
        sanitized[key] = sanitizeParam(value)
      }
      return sanitized
    }
  }, [rawParams])

  return safeParams
}
